import {propsType} from './Toktokquiz-c'
import {useUserStore} from "../../../stores/useUserStore";
import React, {useEffect, useLayoutEffect} from "react";
import {ShoppingPresentationValueObject} from "../../../model/vo/content/ShoppingPresentationValueObject";
import {ShoppingIO} from "../../../io/content/ShoppingIO";
import {ExhaustedPage} from "../common/ExhaustedPage";
import {useStatePair} from "../../../type/States";
import {
    useCurrentPage,
    useCurrentPageUpdate,
    useGuideExpirationDate, useHiddenGuideList, useHiddenGuideListUpdate, useIsFinish,
    useNextPage,
    useNextPageUpdate, usePrevPathType, usePrevPathTypeUpdate
} from "../../../stores/useStore";
import {Spinner} from "@fluentui/react-components";
import {ShoppingPathJointEventIO} from "../../../io/content/shoppingPathJointEventIO";
import {EventType} from "../../../constant/EventType";
import Mission from "../../../components/mission/pink_ver1/nshop_quiz/Mission"
import GuideLine from "../../../components/mission/pink_ver1/nshop_quiz/GuideLine"
import CatalogMission from "../../../components/mission/pink_ver1/nshop_quiz/CatalogMission";
import ParticipationCntFullPage from "../common/ParticipationCntFullPage";
import {pinkTheme} from "../../../styles/mission/theme";
import {isVisible} from "../../../utils/bitmask";
import {PathType, PathTypesType} from "../../../constant/pathType";
import {setPathType} from "../../../utils/pathType";
import {ErrorPage} from "../common/ErrorPage";
import {configureErrorTypeAndSetErrorPage} from "../../../utils/ui/configureErrorTypeAndSetErrorPage";
import {checkGuideVisible, setCurrentPage} from "../../../utils/ui/setCurrentPage";
import {getFormattedDateString} from "../../../utils/formatDate";
import {ThresholdPage} from "../common/ThresholdPage";

export default function NshopQuiz(props: propsType) {
    const {mediaCode,campaignCode,mediaId,externalId} = props;
    const data = useStatePair<ShoppingPresentationValueObject | null>(null)
    const setUserData = useUserStore((state) => state.setUserData)
    const isLoading = useStatePair<boolean>(true)
    const pathType = useStatePair<PathTypesType>(PathType["single_productNumber"])
    const userInfo = useUserStore()

    const currentPage = useCurrentPage()
    const nextPage = useNextPage()
    const expirationDate = useGuideExpirationDate()
    const updateExpirationDate = useHiddenGuideListUpdate()
    const hiddenGuideList = useHiddenGuideList()

    const updateCurrentPage = useCurrentPageUpdate()
    const updateNextPage = useNextPageUpdate()
    const updateHiddenGuideList = useHiddenGuideListUpdate()
    const prevPathType = usePrevPathType()
    const updatePrevPathType = usePrevPathTypeUpdate()

    // hiddenGuideList 초기화
    useEffect(() => {
        if(hiddenGuideList.length != 0) updateHiddenGuideList([])
    }, []);
    //오늘 하루 보지 않기 기능생길때까지만 넣어둘 코드


    const getShoppingMission = async () => {
        const missionExternalId = externalId || ''
        try {
            isLoading.setValue(true)
            const v = await ShoppingIO.getData(missionExternalId,10,true,userInfo.shoppingPathJointId)
            console.log("page rendering")
            console.log(v)
            data.setValue(v)
            if(v) {
                setUserData(v.userId.toString(), v.shoppingPathJointId.toString(), window.location.href, getFormattedDateString(new Date()))
                pathType.setValue(setPathType(v.pathType))
                setCurrentPage(v,hiddenGuideList,currentPage,nextPage,updateCurrentPage,updateNextPage,updateHiddenGuideList,updatePrevPathType,prevPathType,v.pathType)
            }
        } catch(e : any) {
            console.error(e)
            let ErrorString = e.toString()
            data.setValue(null)
            configureErrorTypeAndSetErrorPage(ErrorString,window.location.href, updateCurrentPage)
        } finally {
            isLoading.setValue(false)
        }
    }

    const browserReload = async () => {
        const missionExternalId = externalId || ''
        try {
            isLoading.setValue(true)
            const v = await ShoppingIO.getData(missionExternalId,10,false,null)
            console.log("browser reload")
            console.log(v)
            data.setValue(v)
            if(v) {
                setUserData(v.userId.toString(), v.shoppingPathJointId.toString(), window.location.href, getFormattedDateString(new Date()))
                pathType.setValue(setPathType(v.pathType))
                setCurrentPage(v,hiddenGuideList,currentPage,nextPage,updateCurrentPage,updateNextPage,updateHiddenGuideList,updatePrevPathType,prevPathType,v.pathType)
            }
        } catch(e : any) {
            console.error(e)
            let ErrorString = e.toString()
            data.setValue(null)
            configureErrorTypeAndSetErrorPage(ErrorString, window.location.href , updateCurrentPage)
        } finally {
            isLoading.setValue(false)
        }
    }

    const otherMissionBtnClick = () => {
        browserReload()
            .then(()=>{
                if (data.value) {
                    ShoppingPathJointEventIO.post({
                        shoppingPathJointId:data.value.shoppingPathJointId,
                        userId:data.value.userId,
                        misc:mediaId,
                        eventType:EventType.ShoppingAnotherMissionClick
                    }).then(
                        v=>console.log(v)
                    ).catch(e=>console.error(e))
                    if(data.value.pathType){
                        pathType.setValue(setPathType(data.value.pathType))
                    }}

            })
            .catch(e=>console.error(e))
    }

    useEffect(() => {
        if(userInfo.shoppingPathJointId == null || currentPage == 'ErrorPage') browserReload();
        else getShoppingMission()

        checkGuideVisible(expirationDate,updateExpirationDate)
    }, [externalId])

    useEffect(() => {
        if (data.value) {
            ShoppingPathJointEventIO.post({
                shoppingPathJointId:data.value.shoppingPathJointId,
                userId:data.value.userId,
                misc: mediaId,
                eventType:EventType.Landing,

            }).then(
                v=>console.log(v)
            ).catch(e=>console.error(e))
        }
    }, [data.value])

    if(isLoading.value){
        return  <Spinner />
    }
    else{
        if (currentPage === 'ExhaustedPage') {
            return <ExhaustedPage />
        }
        if (currentPage === 'ErrorPage') {
            return <ErrorPage />
        }
        if(currentPage === 'ParticipationCntFullPage') {
            return <ParticipationCntFullPage/>
        }
        if(currentPage === 'ThresholdPage') {
            return <ThresholdPage/>
        }
        if(currentPage === 'GuideLine'){
            return <GuideLine data={data.value} primaryColor={pinkTheme[pathType.value]} />
        }
        if(currentPage === 'Mission'){

            if(data.value && isVisible(data.value.pathType,1)) return <CatalogMission otherMissionBtnClick={otherMissionBtnClick} mediaCode={mediaCode} mediaId={mediaId} data={data.value} isLoading={isLoading.value} primaryColor={pinkTheme[pathType.value]} />

            return <Mission otherMissionBtnClick={otherMissionBtnClick} mediaId={mediaId} mediaCode={mediaCode} data={data.value} isLoading={isLoading.value} primaryColor={pinkTheme[pathType.value]}/>
        }
    }

    return (
        <Mission otherMissionBtnClick={otherMissionBtnClick} mediaId={mediaId} mediaCode={mediaCode} data={data.value} isLoading={isLoading.value} primaryColor={pinkTheme[pathType.value]}/>
    );

}